module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mojito@3x_292639.jpg";